<template>
  <div class="manual-page">
    <SubPageHeader title="说明手册" />
    <div class="manual-list">
      <div v-for="item in manualItems" :key="item.title" class="manual-item">
        <div class="left">
          <img class="manual-icon" :src="item.icon" :alt="item.title" />
          <span class="manual-title">{{ item.title }}</span>
        </div>
        <span class="arrow">&gt;</span>
      </div>
    </div>
  </div>
</template>

<script>
import SubPageHeader from '../component/SubPageHeader.vue';

export default {
  name: 'ManualPage',
  components: {
    SubPageHeader
  },
  data() {
    return {
      manualItems: [
        { icon: require('@/assets/img/mine/h5.png'), title: '天翼党建（VR版）H5操作手册【V2.0】' },
        { icon: require('@/assets/img/mine/space.png'), title: '元宇宙党建空间操作手册【V2.0】' },
        { icon: require('@/assets/img/mine/tpl.png'), title: '天翼党建VR版后台操作手册【V2.0】' }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.manual-page {
  min-height: 100vh;
  background: #ffffff;
}

.manual-list {
  margin: 0 5.12821vw;
  border-top: 0.25641vw solid #ececec;
}

.manual-item {
  height: 14.35897vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.25641vw solid #ececec;
}

.left {
  display: flex;
  align-items: center;
  gap: 3.07692vw;
}

.manual-icon {
  width: 5.64103vw;
  height: 5.64103vw;
  object-fit: contain;
  display: block;
}

.manual-title {
  font-size: 4.5vw;
  color: #5f6a7a;
}

.arrow {
  color: #1f1f1f;
  font-size: 5.12821vw;
  line-height: 1;
}
</style>
